import React, { useMemo } from 'react';

import { useGetDistributorManagementFeeAnalyticsQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import withProducts from './withProductSelectHOC';
import DataContainer from './DataContainer';

const processResponse = data => data.filter(d => typeof d.value !== 'undefined').reverse();
const getMappedData = data => data.map(d => +d.value?.replace(/,/gi, '') || 0);
const getMappedCategories = data => data.map(d => `Q-${d.quarter} '${(d.year + '').slice(2)}`);

const ManagementFeeData = props => {
    const { products, product, setProduct } = props;
    const selectedProductName = useMemo(
        () => (product === 'all' ? texts.ALL_1 : products.find(p => p.id === +product)?.name),
        [products, product]
    );

    const { data: managementFeeData = [], isLoading: loading } =
        useGetDistributorManagementFeeAnalyticsQuery({
            fundId: product === 'all' ? undefined : +product,
        });

    const preparedResponse = useMemo(() => processResponse(managementFeeData), [managementFeeData]);

    const series = useMemo(() => {
        const mappedData = getMappedData(preparedResponse);
        return mappedData.length ? [{ name: selectedProductName, data: mappedData }] : [];
    }, [preparedResponse, selectedProductName]);

    const categories = useMemo(() => getMappedCategories(preparedResponse), [preparedResponse]);

    return (
        <DataContainer
            title={texts.MANAGEMENT_FEE_COMMISSIONS}
            product={product}
            setProduct={setProduct}
            products={products}
            loading={loading}
            chartCategories={categories}
            chartSeries={series}
        />
    );
};

export default withProducts(ManagementFeeData);
